import script from "./Calling-C2CVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./Calling-C2CVideo.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__